import styled from '@emotion/styled'
import { colors, fontFamilies } from '@configs/styles/config'

const Body = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  z-index: 1;
  position: relative;
  max-width: 1440px;
  margin: auto;
`
const FixedPart = styled.div`
  display: flex;
  flex-direction: column;
  width: 60%;
  max-width: 939px;
  @media (max-width: 1050px) {
    width: 100%;
    max-width: 100%;
  }
`
const BackgroundColorFixed = styled.div<{ url: string }>`
  display: flex;
  position: absolute;
  width: 100vw;
  /* background-image: url(${(props) => props.url}); */
  background-color: ${colors.uguLightLightGrey};
  top: 4rem;
  left: 0;
  align-items: center;
  height: 20rem;
  z-index: 1;
  /* padding: 0 5vw; */
  /* margin-left: 35vw; //this fixes a bug */
`
const CourseInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 49rem;
  background-color: transparent;
  padding-top: 1rem;
  z-index: 2;
  margin-bottom: 1.5rem;
`
const CourseTitle = styled.h1`
  /* display: none; */
  font-family: ${fontFamilies.bold};
  letter-spacing: 0rem;

  @media (min-width: 430px) {
    font-size: 1.5rem;
    word-wrap: break-word;
    color: #1a1e3d;
    font-size: 26px;
    font-style: normal;
    line-height: normal;
    margin-top: 4px;
  }
  @media (max-width: 1050px) {
    margin-top: 1.6rem;
  }
`
const AuthorName = styled.div`
  margin-top: -4px;
  font-size: 14px;
  color: #1a1e3d;

  b {
    font-weight: 500;
  }
`
const NumbersContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 1rem;
  flex-wrap: wrap;
`
const ShortDescriptionFlex = styled.div`
  opacity: 0.8;
  font-size: 0.875rem;
  margin-top: 1rem;
  color: #1a1e3d;
  overflow: hidden;
  transition: 0.9s;
`
const ButtonsFlex = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 1.5rem;
  flex-wrap: wrap;
`
const ReportBlock = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 3rem;
`
const FloatingPart = styled.div`
  position: relative;
  padding-top: 1rem;
  width: 27rem;
  margin-left: 20px;
  justify-self: flex-end;
  @media (max-width: 1050px) {
    display: none;
  }
`

const TopContainer = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  display: flex;
  justify-content: space-around;
  padding-top: 0.46rem;
  padding-bottom: 40px;
`
const DescriptionHeader = styled.div`
  font-size: 21px;
  margin-top: 27px;
  font-family: ${fontFamilies.semiBold};
`

const ShowMore = styled.div`
  display: flex;
  margin-top: 20px;
  justify-content: space-around;
  align-items: center;
`

const ShowMoreLine = styled.div`
  border-bottom: 1px solid black;
  flex: 1;
  margin: 0 3%;
`
const ShowMoreButton = styled.div`
  padding: 3px 25px;
  border: 1px black solid;
  display: flex;
  justify-content: space-around;
  border-radius: 20px;
  cursor: pointer;
`

const TopBg = styled.div`
  position: absolute;
  background-color: rgb(248, 248, 248);
  width: 100%;
  z-index: 0;
  left: 0px;
  top: ${(props) => props.top};
  height: ${(props) => props.topBlockHeight - 12 + 'px'};
  /* max-height: 38vh; */
  @media (max-width: 1050px) {
    /* max-height: auto; */
    height: ${(props) => props.topBlockHeight - 12 + 'px'};
    top: ${(props) => props.top};
  }
`

const VideoPlayerWrapper = styled.div`
  width: 100%;
  min-height: 56vw;
  border-radius: 10px;
  position: relative;
  background-color: ${colors.uguIvory};
  @media (max-width: 1050px) {
    margin-top: 1.2rem;
  }
`
const PlayIconContainer = styled.div`
  display: flex;
  border-radius: 100%;
  width: 2.8rem;
  height: 2.8rem;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(1.3);
`
const PlayIconWrapper = styled.div`
  position: relative;
  display: flex;
  :hover {
    cursor: pointer;
  }
`

const CoursePosterImage = styled.img`
  width: ${(props) => props.width};
  border-radius: ${(props) => props.borderRadius};
  background-color: #a5afff;
  object-fit: ${(props) => props.objectFit};
  height: ${(props) => props.height};
  border-radius: 8px;
  object-fit: cover;
  min-height: 56vw;
  max-height: 56vw;
  width: 100%;
  @media (max-width: 600px) {
    width: 100%;
  }
`

const FixedBuyBlock = styled.div`
  position: fixed;
  width: 100%;
  background-color: #fff;
  z-index: ${(props) => (props.isTitleInViewPort ? -1 : 10)};
  padding: 0.8rem 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  bottom: ${(props) => (props.isScrollingUp ? '60px' : '0px')};
  transition:
    all 0.1s ease-in,
    opacity 0.2s ease-in-out;
  left: 0;
  gap: 1rem;
  flex-wrap: wrap;
  border-top: 1px solid ${colors.uguGray};
  opacity: ${(props) => (props.isTitleInViewPort ? 0 : 1)};
  /* opacity: ${(props) => (props.isTitleInViewPort ? 0 : 1)}; */
  @media (min-width: 1050px) {
    display: none;
  }
  @media (min-width: 1001px) {
    bottom: 0;
  }
`

const ShareHeader = styled.div`
  font-family: ${fontFamilies.regular} !important;
  line-height: normal;
  color: ${colors.uguPurple} !important;
  font-size: 24px;
  letter-spacing: 0rem;
  @media (max-width: 640px) {
    font-size: 22px;
  }
`

const ShareModalWrapper = styled.div`
  width: 100%;
`
const CourseDetails = styled.div`
  display: flex;
  gap: 12px;
`
const CourseName = styled.div`
  max-width: 507px;
  width: 100%;
  font-family: ${fontFamilies.semiBold};
  font-size: 20px;
  line-height: 1.12rem;
  color: ${colors.uguPurple};
  @media (max-width: 600px) {
    font-size: 18px;
  }
`

const InfoWrapper = styled.div`
  display: flex;
  margin-top: 15px;
  gap: 0.5rem;
  margin-bottom: 15px;
  align-items: start;
  flex-wrap: wrap;
  flex-direction: column;
`

const ShareBlock = styled.div`
  display: flex;
  margin-top: 20px;
  flex-wrap: wrap;
  gap: 1rem;
`

const ButtonWrapper = styled.div`
  flex: 1;
  max-width: 48%;
  @media screen and (min-width: 640px) {
    min-width: 30%;
  }
`

const InfoText = styled.div`
  font-family: ${fontFamilies.light};
  font-size: 15px;
  color: #555;
  display: flex;
  align-items: center;
`

const PriceWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-right: 1rem;
  align-self: flex-end;
`

const Price = styled.div<{ active?: boolean }>`
  /* font-weight: ${(props) => (props.active ? 'bold' : 'normal')}; */
  font-size: 1.2rem;
  font-family: ${fontFamilies.semiBold};
  letter-spacing: 0rem;
  text-decoration: ${(props) => (props.active ? '' : 'line-through')};
  color: ${(props) => (props.active ? colors.uguPurple : colors.uguGrey)};
  @media (min-width: 600px) {
    font-size: ${(props) => (props.coursePage ? '14px' : '1.5rem')} !important;
  }
`

const OtherCourses = styled.div`
  display: flex;
  flex-direction: column;
`
const OtherCoursesHeading = styled.span`
  font-family: ${fontFamilies.semiBold};
  color: ${colors.uguPurple};
  font-size: 1.5rem;
  word-wrap: break-word;
  color: ${colors.uguPurple};
  font-size: 1.6rem;
  font-style: normal;
  line-height: normal;
  margin-top: 4px;
  letter-spacing: 0rem;
  margin-top: 1rem;
  margin-bottom: 0.65rem;
`
const SectionsRouteContainer = styled.div`
  display: flex;
  overflow: auto;
  align-items: center;
  gap: 0.4rem;
  @media (max-width: 1050px) {
    /* margin-top: 1.5rem; */
    display: ${(props) => (props.hiddenOnMobile ? 'none' : 'flex')};
  }
`

const RouteButton = styled.button`
  color: #1a1e3d;
  padding: 0;
  font-size: 1rem;
  background: none;
  transition: 0.2s;
  white-space: nowrap;
  line-height: 26px;
  font-weight: 300;
  letter-spacing: 0rem;
  font-family: ${fontFamilies.regular};
  @media (max-width: 640px) {
    font-size: 1rem;
  }
  @media (max-width: 480px) {
    font-size: 0.85rem;
  }
  :hover {
    font-weight: 500;
    cursor: pointer;
  }
`

const Separator = styled.div`
  font-size: 1rem;
  color: #1a1e3d;
`

export {
  Body,
  FixedPart,
  BackgroundColorFixed,
  CourseInfoContainer,
  CourseTitle,
  AuthorName,
  NumbersContainer,
  ShortDescriptionFlex,
  ButtonsFlex,
  ReportBlock,
  FloatingPart,
  TopContainer,
  DescriptionHeader,
  ShowMore,
  ShowMoreLine,
  ShowMoreButton,
  TopBg,
  VideoPlayerWrapper,
  PlayIconContainer,
  PlayIconWrapper,
  CoursePosterImage,
  FixedBuyBlock,
  ShareHeader,
  ShareModalWrapper,
  InfoWrapper,
  ShareBlock,
  ButtonWrapper,
  InfoText,
  PriceWrapper,
  Price,
  CourseDetails,
  CourseName,
  OtherCourses,
  OtherCoursesHeading,
  SectionsRouteContainer,
  RouteButton,
  Separator,
}
